// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".trade-last-orders-tabs[data-v-72d2be32]{display:flex;align-items:center}.trade-last-orders-tabs[data-v-72d2be32] .exc-tabs__tab{padding-right:5px}.trade-last-orders-tabs[data-v-72d2be32] .exc-tabs__tab:last-child{padding-right:0}.trade-last-orders-tabs__img[data-v-72d2be32]{border-radius:.1875rem;max-width:1.125rem;max-height:1.125rem;transition-duration:.25s}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
